export default __webpack_public_path__ + "static/media/keynote17.69f951d6.jpeg";